import {useState} from 'react';
import {SimplePageLayout} from '@flexinet/ui-components';

import {IndexPageHeader} from '../components/IndexPageHeader';
import {RecordsTable} from "../tables/RecordsTable.tsx";
import {Card} from '../types';

export const IndexPage = () => {
    const [selectedRecords, setSelectedRecords] = useState<Card[]>([]);

    const selectedIds = selectedRecords.map(r => r.id);

    const handleDeleteComplete = () => {
        setSelectedRecords([]);
    };

    return (
        <SimplePageLayout
            pageHeader={<IndexPageHeader selectedIds={selectedIds} onDeleteComplete={handleDeleteComplete}/>}
        >
            <RecordsTable
                selectedRecords={selectedRecords}
                setSelectedRecords={setSelectedRecords}
            />
        </SimplePageLayout>
    );
};
